import Diagnosenbezeichnung from '@/types/Diagnosenbezeichnung';

export default class Diagnose {
    /** PK | erforderlich **/
    public diagnose_id: number | null = null;
    /**  max. 40 Zeichen | erforderlich  **/
    public diagnose: string | null = null;
    /** max. 1 Zeichen | j/n **/
    public gueltig: string | null = 'j';

    public diagnosenbezeichnungen: Diagnosenbezeichnung[] = [];

    constructor(data?: Partial<Diagnose>) {
        Object.assign(this, data);
    }
}
